export default __webpack_public_path__ + "static/media/star-icon.9bacc9dd.svg";